<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card card-form">

          <div class="card-header">
            <div class="row">
              <div class="col">
                <div class="pull-left">
                  <h4 class="card-title float-left">
                    {{ $t("fitment.plus.list") }}
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body">

            <div class="row">
              <div class="col-12">

                <div class="row">


                  <div class="col-12 col-md-6">
                    <div class="row">
                      <div class="col-12 col-md-6">

                        <div class="form-group">
                          <label
                              :class="$v.fitment.productCategoryPlusDto.$error ? 'red' : ''">
                            {{ $t('config.products.productCategory.title') }}<span
                              class="red">*</span></label>
                          <v-select v-model="fitment.productCategoryPlusDto" label="name"
                                    :class="{invalid : $v.fitment.productCategoryPlusDto.$error}"
                                    :options="productCategories"
                                    :filterable="false"
                                    @search="onCategorySearch"
                                    @search:focus="onCategoryFocus">
                            <template slot="option" slot-scope="option" v-if="option">
                              <div v-html="option.name"></div>
                            </template>
                            <template slot="selected-option"
                                      v-if="fitment.productCategoryPlusDto && fitment.productCategoryPlusDto && fitment.productCategoryPlusDto.name">
                              <div v-html="fitment.productCategoryPlusDto.name"
                                   @click="$eventBus.$emit('search:focus')"></div>
                            </template>
                            <span slot="no-options">{{ $t("empty") }}</span>
                          </v-select>
                        </div>

                        <div class="form-group">
                          <label
                              :class="$v.fitment.productManufactureDto.$error ? 'red' : ''">
                            {{ $t('config.products.productManufacture.title') }}<span
                              class="red">*</span></label>
                          <v-select v-model="fitment.productManufactureDto" label="name"
                                    :class="{invalid : $v.fitment.productManufactureDto.$error}"
                                    :options="manufactures"
                                    :filterable="false"
                                    @search="onProductManufactureSearch()"
                                    @search:focus="onProductManufactureFocus()">
                            <template slot="option" slot-scope="option" v-if="option">
                              <div v-html="option.name"></div>
                            </template>
                            <template slot="selected-option"
                                      v-if="fitment.productManufactureDto && fitment.productManufactureDto.name">
                              <div v-html="fitment.productManufactureDto.name"
                                   @click="$eventBus.$emit('search:focus')"></div>
                            </template>
                            <span slot="no-options">{{ $t("empty") }}</span>
                          </v-select>
                        </div>

                        <div class="form-group">

                          <label
                              :class="$v.fitment.countryDto.$error ? 'red' : ''">
                            {{
                              fitment.fitmentType === 'JEWELRY' ? 'Заргарлик буйум ишлаб чиққарилган мамлакат' : $t("fitment.madeCountry")
                            }} <span class="red">*</span></label>
                          <v-select v-model="fitment.countryDto" label="name"
                                    :options="countryList"
                                    :filterable="false"
                                    @search="onCountrySearch"
                                    @search:focus="onCountryFocus"
                                    :class="{invalid : $v.fitment.countryDto.$error}">
                            <template slot="option" slot-scope="option" v-if="option">
                              <div v-html="option.name"></div>
                            </template>
                            <template slot="selected-option"
                                      v-if="fitment.countryDto && fitment.countryDto.name">
                              <div v-html="fitment.countryDto.name"
                                   @click="$eventBus.$emit('search:focus')"></div>
                            </template>
                            <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                          </v-select>
                        </div>

                        <div class="form-group">
                          <label
                              :class="$v.fitment.useWebSite.$error ? 'red' : ''">
                            {{ $t("fitment.useWebSite") }} <span class="red">*</span></label>
                          <input type="text" class="form-control" v-model="fitment.useWebSite"
                                 :class="{invalid : $v.fitment.useWebSite.$error}"/>
                        </div>

                        <div class="form-group">
                          <label>Олдин ишлатилган ID</label>
                          <input type="text" :disabled="true" class="form-control"
                                 v-model="fitment.fitmentParentId"/>
                        </div>

                        <div class="form-group"
                             v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                          <label
                              :class="$v.fitment.overlayCoefficient.$error ? 'red' : ''">
                            {{ $t("fitment.overlayCoefficient") }} <span
                              class="red">*</span></label>
                          <numeric-input class="form-control" v-model="fitment.overlayCoefficient"
                                         :class="{invalid : $v.fitment.overlayCoefficient.$error}"
                                         :controls="false" :precision="3"></numeric-input>
                        </div>

                        <div class="form-group"
                             v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY' &&
                                                  fitment.fitmentType === 'INSTRUMENTS_INVENTORY_ANIMALS_EQUIPMENT_FIXED_ASSETS'">
                          <label
                              :class="$v.fitment.dilapidationValue.$error ? 'red' : ''">
                            {{ $t("fitment.dilapidationValue") }}
                          </label>
                          <numeric-input class="form-control"
                                         v-model="fitment.dilapidationValue"
                                         @input="changeDilapidationValue14()"
                                         :class="{invalid : $v.fitment.dilapidationValue.$error}"
                                         :precision="0"
                          ></numeric-input>
                        </div>

                        <div class="form-group"
                             v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY' &&
                                                 (fitment.fitmentType === 'BUILDINGS_TRANSMITTERS_MACHINERY_EQUIPMENT' || fitment.fitmentType === 'OTHER') ">

                          <label
                              :class="$v.fitment.dilapidationValue.$error ? 'red' : ''">
                            {{ $t("fitment.dilapidationValue") }}
                            <span class="red">*</span>
                          </label>

                          <select class="form-control" v-model="fitment.dilapidationValue"
                                  :class="{invalid : $v.fitment.dilapidationValue.$error}"
                                  @change="changeDilapidationValue15()">
                            <option value=""></option>
                            <option :value="option" v-for="option in dilapidation15" :key="option">
                              {{ option }}
                            </option>
                          </select>

                        </div>

                      </div>


                      <div class="col-12 col-md-6">

                        <div class="form-group">
                          <label
                              :class="$v.fitment.productSubCategoryPlusDto.$error ? 'red' : ''">
                            {{ $t('config.products.productSubCategory.title') }}<span
                              class="red">*</span></label>
                          <v-select v-model="fitment.productSubCategoryPlusDto" label="name"
                                    :class="{invalid : $v.fitment.productSubCategoryPlusDto.$error}"
                                    :options="productSubCategories"
                                    :filterable="false"
                                    @search="onSubCategorySearch()"
                                    @search:focus="onSubCategoryFocus()"
                                    @input="onChangeMethodSub()">
                            <template slot="option" slot-scope="option" v-if="option">
                              <div v-html="option.name"></div>
                            </template>
                            <template slot="selected-option"
                                      v-if="fitment.productSubCategoryPlusDto && fitment.productSubCategoryPlusDto.name">
                              <div v-html="fitment.productSubCategoryPlusDto.name"
                                   @click="$eventBus.$emit('search:focus')"></div>
                            </template>
                            <span slot="no-options">{{ $t("empty") }}</span>
                          </v-select>
                        </div>

                        <div class="form-group">
                          <label
                              :class="$v.fitment.productModelDto.$error ? 'red' : ''">
                            {{ $t('config.products.productModel.title') }}<span
                              class="red">*</span></label>
                          <v-select v-model="fitment.productModelDto" label="name"
                                    :class="{invalid : $v.fitment.productModelDto.$error}"
                                    :options="productModels"
                                    :filterable="false"
                                    @search="onProductModelSearch()"
                                    @search:focus="onProductModelFocus()">
                            <template slot="option" slot-scope="option" v-if="option">
                              <div v-html="option.name"></div>
                            </template>
                            <template slot="selected-option"
                                      v-if="fitment.productModelDto && fitment.productModelDto.name">
                              <div v-html="fitment.productModelDto.name"
                                   @click="$eventBus.$emit('search:focus')"></div>
                            </template>
                            <span slot="no-options">{{ $t("empty") }}</span>
                          </v-select>
                        </div>

                        <div class="form-group"
                             v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">
                          <label
                              :class="$v.fitment.conditionType.$error ? 'red' : ''">
                            {{ $t("fitment.partConditions") }} </label>
                          <select class="form-control" v-model="fitment.conditionType"
                                  :class="{invalid : $v.fitment.conditionType.$error}"
                          >
                            <option value=""></option>
                            <option :value="option.key" v-for="option in partConditions"
                                    :key="option.key">
                              {{ option.name }}
                            </option>
                          </select>
                        </div>

                        <div class="form-group"
                             v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                          <label
                              :class="!$v.fitment.stoneName.$error ? 'red' : ''">
                            {{ $t("fitment.stoneName") }} </label>
                          <input type="text" class="form-control"
                                 :class="{invalid : $v.fitment.stoneName.$error}"
                                 v-model="fitment.stoneName"/>
                        </div>

                        <div class="form-group"
                             v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">
                          <label
                              :class="!$v.fitment.madeYear.$error ? 'red' : ''">

                            {{ $t("fitment.madeYear") }} </label>
                          <input type="text" class="form-control"
                                 :class="{invalid : $v.fitment.madeYear.$error}"
                                 v-model="fitment.madeYear"/>
                        </div>


                        <div class="form-group"
                             v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                          <label
                              :class="!$v.fitment.metalType.$error ? 'red' : ''">
                            {{ $t("fitment.metalType") }}
                            <span class="red">*</span>
                          </label>
                          <select class="form-control"
                                  :class="{invalid : $v.fitment.metalType.$error}"
                                  @change="calculated()"
                                  v-model="fitment.metalType">
                            <option value="GOLD">{{ $t("fitment.gold") }}</option>
                            <option value="SILVER">{{ $t("fitment.silver") }}</option>
                          </select>
                        </div>


                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-6 col-6">
                              <label
                                  :class="$v.fitment.qty.$error ? 'red' : ''">
                                {{ $t("fitment.qty") }} <span class="red">*</span></label>
                              <numeric-input class="form-control" v-model="fitment.qty"
                                             :class="{invalid : $v.fitment.qty.$error}"
                                             :controls="false" :precision="3"></numeric-input>
                            </div>

                            <div class="col-md-5 col-6">
                              <label>
                                Ўлчов бирликлари
                              </label>
                              <MeasurementTypeSelect :value="fitment.um" :with-change="true"
                                                     @handle-change="umchange(fitment.um)"
                                                     v-model="fitment.um"></MeasurementTypeSelect>
                            </div>

                            <div class="col-md-6 col-6"
                                 v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                              <label
                                  :class="!$v.fitment.weigh.$error ? 'red' : ''">
                                {{ $t("fitment.weigh") }}
                                <span class="red">*</span>
                              </label>
                              <numeric-input class="form-control" v-model="fitment.weigh"
                                             :class="{invalid : $v.fitment.weigh.$error}"
                                             :controls="false" :precision="3"></numeric-input>
                            </div>

                            <div class="col-md-6 col-6"
                                 v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                              <label
                                  :class="!$v.fitment.hallmark.$error ? 'red' : ''">
                                {{ $t("fitment.hallmark") }} <span class="red">*</span></label>
                              <numeric-input class="form-control" v-model="fitment.hallmark"
                                             :class="{invalid : $v.fitment.hallmark.$error}"
                                             :controls="false" :precision="3"></numeric-input>
                            </div>
                          </div>

                        </div>

                        <div class="form-group"
                             v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">
                          <div class="row">
                            <div class="col-md-6 col-6">
                              <label
                                  :class="$v.fitment.governmentPrice.$error ? 'red' : ''">
                                {{ $t("fitment.price") }}
                                <span class="red">*</span>
                              </label>
                              <numeric-input class="form-control" v-model="fitment.governmentPrice"
                                             :class="{invalid : $v.fitment.governmentPrice.$error}"
                                             :controls="false" :precision="3"
                                             @input="calculated()"></numeric-input>
                            </div>
                            <div class="col-md-6 col-6">
                              <label
                                  :class="$v.fitment.currency.$error ? 'red' : ''">
                                {{ $t("config.currency") }}
                                <span class="red">*</span>
                              </label>
                              <select class="form-control" v-model="fitment.currency"
                                      :class="{invalid : $v.fitment.currency.$error}"
                                      @change="calculated()">
                                <option value="UZS">UZS</option>
                                <option value="USD">USD</option>
                                <option value="EUR">EUR</option>
                                <option value="RUB">RUB</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="form-group"
                             v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">
                          <label>{{ $t("fitment.foreign") }}</label>
                          <label class="form-check-label mb-2 ml-5">
                            <input class="form-check-input" type="checkbox"
                                   v-model="fitment.hasCustomsDuty"
                                   @change="calculated()">
                            <span class="form-check-sign"></span>
                          </label>
                        </div>

                      </div>

                    </div>

                    <div class="form-group"
                         v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                      <label
                          :class="!$v.fitment.stonePrice.$error ? 'red' : ''">
                        {{ $t("fitment.stonePrice") }} <span class="red">*</span></label>
                      <numeric-input class="form-control" v-model="fitment.stonePrice"
                                     :class="{invalid : $v.fitment.stonePrice.$error}"
                                     :controls="false" :precision="0"
                                     @input="calculated()"></numeric-input>
                    </div>

                    <!--                    <template v-if="!isPageLoadInit">-->
                    <!--                      <AssetDropZone code="fitmentImageDropZone" label="fitment.photos"-->
                    <!--                                     folder="FitmentImage" :folderName="'Fitment'"-->
                    <!--                                     :data="fitment.fitmentPictures"-->
                    <!--                                     @change="(files) => {fitment.fitmentPictures = files}"-->
                    <!--                                     :removeFile="isRemoveFile"-->
                    <!--                                     :editable="canSave"-->
                    <!--                                     :class="'col-md-12'"-->
                    <!--                      />-->
                    <!--                    </template>-->
                    <template v-if="!isPageLoadInit">
                      <AssetDropZone code="texPassportDropZone" label="fitment.plus.priceListPhoto"
                                     folder="TexPassport" :folderName="'Fitment'"
                                     :data="fitment.fitmentTexPassports"
                                     @change="(files) => {fitment.fitmentTexPassports = files}"
                                     :class="'col-md-12'"
                      />
                    </template>

                  </div>

                  <div class="col-12 col-md-6">
                    <b-form-group v-slot="{ ariaDescribedby }">
                      <b-form-radio-group
                          v-model="selectedFitmentDocsTab"
                          :options="[
                                              { text: 'Расмлари', value: 'images' }]"
                          :aria-describedby="ariaDescribedby"
                          button-variant="form-radio-group"
                          name="radio-btn-outline1"
                          buttons
                      ></b-form-radio-group>
                    </b-form-group>

                    <div v-if="selectedFitmentDocsTab === 'images'" class="px-3">
                      <carousel :perPage="1"
                                :navigationEnabled="true"
                                :navigationNextLabel="next"
                                :navigationPrevLabel="prev">
                        <slide v-for="(photo) in fitment.fitmentPictures" v-bind:key="photo.id">
                          <div v-if="photo && photo.type !== 'application/pdf'">
                            <inner-image-zoom :src="photo.filePath"
                                              :height="500"
                                              :hideHint="true"
                                              :zoomScale="1.2"
                            ></inner-image-zoom>
                          </div>
                          <div v-else-if="photo && photo.type === 'application/pdf'">
                            <iframe :src="photo.filePath" width="100%"
                                    style="height: 600px"></iframe>
                          </div>
                        </slide>
                      </carousel>
                    </div>
                  </div>


                </div>

                <div class="calculate row m-1">
                  <div class="col-4">
                    <h4 class="ml-3 text-primary">
                      <b>Харажат усулдаги қиймати:<br/></b>
                    </h4>
                    <h4 class="ml-3 text-primary">
                      <b>{{ fitment.totalGovPrice | currency('', 0, {thousandsSeparator: ' '}) }}
                        сўм</b>
                    </h4>
                  </div>
                  <div class="col-4">
                                <span class="mr-3">
                                    Техник холати:
                                    <b>{{ technicalConditionText }}<br/><br/></b>
                                </span>
                    <span class="mr-3" v-if="fitment.currency === 'USD'">
                                    Доллар курси:
                                    <b>{{
                                        fitment.usdCurrencyRate | currency('', 2, {thousandsSeparator: ' '})
                                      }} сўм<br/><br/></b>
                                </span>
                    <span class="mr-3" v-if="fitment.currency === 'EUR'">
                                    Евро курси:
                                    <b>{{
                                        fitment.eurCurrencyRate | currency('', 2, {thousandsSeparator: ' '})
                                      }} сўм<br/><br/></b>
                                </span>
                    <span class="mr-3" v-if="fitment.currency === 'RUB'">
                                    Рубл курси:
                                    <b>{{
                                        fitment.rubCurrencyRate | currency('', 2, {thousandsSeparator: ' '})
                                      }} сўм<br/><br/></b>
                                </span>
                    <span v-if="fitment.fitmentType && fitment.fitmentType !== 'JEWELRY'">
                                    Эскириш қиймати:
                                    <b>{{ fitment.dilapidationValue }} %<br/><br/></b>
                                </span>
                    <span v-if="fitment.fitmentType && fitment.fitmentType === 'JEWELRY'">
                                    1 грамм соф {{ fitment.metalTypeName }}нинг жаҳон бозоридаги нархи :
                                    <b>{{
                                        fitment.gramPriceInSum | currency('', 2, {thousandsSeparator: ' '})
                                      }} сўм<br/><br/></b>
                                </span>
                    <span>
                                    Энг кам иш хакки:
                                    <b>{{ minSalary | currency('', 2, {thousandsSeparator: ' '}) }} сўм</b>
                                </span>
                  </div>
                  <div class="col-4">
                                <span class="mr-3" v-if="fitment.hasCustomsDuty">
                                    Солик ставкаси (ККС):
                                    <b>{{ fitment.vat }} %<br/><br/></b>
                                </span>
                    <span class="mr-3" v-if="fitment.hasCustomsDuty">
                                    Транспорт харажатлари:
                                    <b>{{ fitment.road }} %<br/><br/></b>
                                </span>
                    <span class="mr-3" v-if="fitment.hasCustomsDuty">
                                    Божхона хужжатларини расмийлаштириш:
                                    <b>{{
                                        fitment.customsClearance | currency('', 2, {thousandsSeparator: ' '})
                                      }} {{ isNewStandard ? 'сўм' : '%' }}<br/><br/></b>
                                </span>
                    <span class="mr-3" v-if="fitment.hasCustomsDuty">
                                    Божхона божи:
                                    <b>{{ fitment.customsDuty }} %</b>
                                </span>
                  </div>
                </div>

              </div>
            </div>

          </div>

          <div class="row mt-5">
            <div class="col-12 btns-box">
              <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                {{ $t("action.cancel") }}
              </button>

              <button class="all-btn add-btn" @click="save" :disabled="processing">
                {{ $t("action.save") }}
              </button>

            </div>
          </div>


        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {numericTypes} from '@/shared/constants/mask'
import {EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
import initFilterModel from '@/shared/filter';
import AssetDropZone from '@/views/asset/AssetDropZone'
import {required, requiredUnless, minValue} from 'vuelidate/lib/validators';
import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
import InnerImageZoom from 'vue-inner-image-zoom';
import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
import {VBToggle} from 'bootstrap-vue/es/directives/toggle/toggle'
import {BFormRadioGroup} from 'bootstrap-vue/es/components/form-radio/form-radio-group'
import {BFormGroup} from 'bootstrap-vue/es/components/form-group/form-group'
import {PART_CONDITION} from "@/shared/constants/fitment";
import MeasurementTypeSelect from '@/components/MeasurementTypeSelect';

export default {
  name: "fitment-add-edit",
  components: {
    AssetDropZone,
    PreviewDropZone,
    BCollapse,
    BFormGroup,
    BFormRadioGroup,
    InnerImageZoom,
    MeasurementTypeSelect
  },
  directives: {
    'b-toggle': VBToggle
  },
  data() {
    return {
      processing: false,
      loading: {},
      show: false,
      isPageLoadInit: false,
      numericTypes: numericTypes,
      productCategoryFilter: initFilterModel(),
      productManufactureFilter: initFilterModel(),
      productModelFilter: initFilterModel(),
      subCategoryFilter: initFilterModel(),
      filter: initFilterModel(),
      selectedFitmentDocsTab: "images",
      prev: '<i class="material-icons">keyboard_arrow_left</i>',
      next: '<i class="material-icons">keyboard_arrow_right</i>',
      isAddValueCollapse: false,
      technicalConditionText: '',
      assetItemId: null,
      fitment: {
        id: null,
        evlObjectType: 'Fitment',
        prepayment: 0,
        evlValueType: 'Market',
        displayReport: false,
        evaluationFitments: [
          {
            id: null,
            assetItemId: null,
            productCategoryPlusDto: {},
            productSubCategoryPlusDto: {},
            productManufactureDto: {},
            productModelDto: {},
            conditionType: null,
            fitmentType: null,
            fitmentPictures: [],
            fitmentTexPassports: [],
            appraisalStatusEnum: 'Unreviewed',
            parentStatus: 'Pending',
            parentAppraisalStatusEnum: 'Unreviewed',
            metalType: null,
            um: null,
            metalTypeName: '',
            qty: 0,
            dilapidationValue: null,
            governmentPrice: null,
            technicalCondition: null,
            totalGovPrice: 0,
            stonePrice: null,
            hallmark: null,
            weigh: null,
            overlayCoefficient: null,
            useWebSite: null,
            fitmentParentId: null,
            apiData: false,
            hasCustomsDuty: false,
            currency: null,
            countryDto: null,
            usdCurrencyRate: 0,
            eurCurrencyRate: 0,
            rubCurrencyRate: 0,
            vat: 0,
            road: 0,
            customsClearance: 0,
            customsDuty: 0,
            gramPriceInSum: 0
          },
        ],


        executivePlaylistFiles: [],
        checkPaymentFiles: [],// to'lov haqidagi hujjatlar
      },

      productCategories: [],
      productSubCategories: [],
      manufactures: [],
      productModels: [],
      countryList: [],
      dilapidation15: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 97.5, 100],
      propertyTypes: EVL_PROPERTY_TYPES,
      partConditions: PART_CONDITION,
      status: null,
      isDirector: false,
      isAppraiser: false,
      isNewStandard: false,
      minSalary: 0
    }
  },
  validations() {
    return {
      fitment: {
        productCategoryPlusDto: {
          id: {
            required: required
          }
        },
        productSubCategoryPlusDto: {
          id: {
            required: required
          }
        },
        productManufactureDto: {
          id: {
            required: required
          }
        },
        productModelDto: {
          id: {
            required: required
          }
        },
        countryDto: {
          id: {
            required: required
          }
        },
        qty: {
          required: requiredUnless(() => {
            return (this.entiteCreateType === 'EXPERT2') && minValue(1);
          }),
        },
        hallmark: {
          required: requiredUnless(() => {
            return (this.fitmentType !== 'JEWELRY');
          })
        },
        weigh: {
          required: requiredUnless(() => {
            return (this.fitmentType !== 'JEWELRY');
          })
        },
        stoneName: {
          required: requiredUnless(() => {
            return (this.fitmentType !== 'JEWELRY');
          })
        },
        madeYear: {
          required: requiredUnless(() => {
            return (this.fitmentType !== 'JEWELRY');
          })
        },
        metalType: {
          required: requiredUnless(() => {
            return (this.fitmentType !== 'JEWELRY');
          })
        },
        stonePrice: {
          required: requiredUnless(() => {
            return (this.fitmentType !== 'JEWELRY');
          })
        },
        overlayCoefficient: {
          required: requiredUnless(() => {
            return (this.fitmentType !== 'JEWELRY');
          })
        },
        conditionType: {
          required: requiredUnless(() => {
            return (this.fitmentType !== 'JEWELRY');
          })
        },
        useWebSite: {
          required: required
        },
        dilapidationValue: {
          required: requiredUnless(() => {
            return (this.fitment.fitmentType !== 'JEWELRY');
          })
        },
        governmentPrice: {
          required: requiredUnless(() => {
            return (this.fitmentType !== 'JEWELRY' || this.entiteCreateType === 'EXPERT2');
          })
        },
        currency: {
          required: requiredUnless(() => {
            return (this.fitmentType !== 'JEWELRY' || this.entiteCreateType === 'EXPERT2');
          })
        }
      }
    };
  },
  computed: {

    canConfirm() {
      return this.fitment.appraisalStatusEnum === 'Rated' && this.hasPermission('NEW_FITMENT_CONFIRM');
    },

    canReject() {
      return this.hasPermission('NEW_FITMENT_EDIT') && this.fitment.appraisalStatusEnum === 'Unreviewed' && !this.fitment.hasAppraiserReportEsp;
    },
    canRemoveFile() {
      return this.status && this.status !== 'Rated' && this.status !== 'Confirmed' && this.status !== 'Rejected' && this.hasPermission('NEW_FITMENT_IMAGE_DELETE')
    },
    canSendAgent() {
      return !this.fitment.appraisalStatusEnum && this.hasPermission('NEW_FITMENT_EDIT')
    },
  },
  methods: {
    init() {
      const vm = this;
      const id = this.$route.params.id;


      console.log("err this.$route = ", this.$route);


      vm.assetItemId = this.$route.params.parentId;

      if (vm.assetItemId && vm.assetItemId > 0) {
        vm.fitment.assetItemId = vm.assetItemId;
      }


      const promises = [];
      if (id && id > 0) {
        vm.isPageLoadInit = true;
        promises.push(this.$http.get('fitment/item/' + id));

        Promise.all(promises).then(function (values) {
          if (values.length >= 0) {
            const editData = values[0].data;
            vm.fitment = editData;
            if (vm.fitment) {
              vm.getMetalType(vm.fitment);
            }
            vm.status = editData.appraisalStatusEnum;
            vm.isPageLoadInit = false;
          }
        });
      }
    },
    cancel() {
      this.$router.push('/asset-plus/item/edit/' + this.fitment.assetItemId);
    },
    save() {
      this.saveAndObjects();
    },
    saveAndObjects() {
      if (!this.fitment.dilapidationValue && this.fitment.fitmentType === 'INSTRUMENTS_INVENTORY_ANIMALS_EQUIPMENT_FIXED_ASSETS') {
        this.fitment.dilapidationValue = 0;
      }
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.fitment.prepayment && !(this.fitment.prepayment >= 0 && this.fitment.prepayment <= 100)) {
        this.$swal({
          title: this.$t('messages.common.warning'),
          text: this.$t('Олдиндан тўлов фоизи 0% дан 100% гача!'),
          type: 'warning'
        });
        return;
      }

      this.processing = true;

      this.$http.post('/fitment/item/plus/save', this.fitment)
          .then(res => {

            if (res && res.data && res.data.status === 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.realEstate.statusSuccess'),
                type: 'success'
              });
              this.$router.push('/asset-plus/item/edit/' + this.fitment.assetItemId);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t('messages.realEstate.statusWarning'),
                type: 'warning'
              });
            }
            this.processing = false;
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.realEstate.error'),
              type: 'error'
            });
            this.processing = false;
          });
    },

    getMetalType() {
      const vm = this;
      const promises = [];
      let objectType = "Fitment";
      promises.push(vm.$http.get('fitment/metalType/' + vm.fitment.id + '/' + vm.fitment.assetItemId + '/' + objectType))
      Promise.all(promises).then(function (values) {
        if (values.length >= 0) {
          const result = values[0].data;

          vm.isNewStandard = result.data.isNewStandard;
          vm.metalTypes = result.data.metalType;
          if (!vm.fitment.usdCurrencyRate) {
            vm.fitment.usdCurrencyRate = result.data.usdRate;
          }
          if (!vm.fitment.eurCurrencyRate) {
            vm.fitment.eurCurrencyRate = result.data.eurRate;
          }
          if (!vm.fitment.rubCurrencyRate) {
            vm.fitment.rubCurrencyRate = result.data.rubRate;
          }
          if (!vm.fitment.vat) {
            vm.fitment.vat = result.data.vat;
          }
          if (!vm.fitment.road) {
            vm.fitment.road = result.data.road;
          }
          if (!vm.fitment.customsClearance) {
            vm.fitment.customsClearance = result.data.customsClearance;
          }
          if (result.data.minSalary) {
            vm.minSalary = result.data.minSalary;
          }
          if (vm.fitment.fitmentType === 'INSTRUMENTS_INVENTORY_ANIMALS_EQUIPMENT_FIXED_ASSETS') {
            vm.changeDilapidationValue14();
          } else if (vm.fitment.fitmentType === 'BUILDINGS_TRANSMITTERS_MACHINERY_EQUIPMENT') {
            vm.changeDilapidationValue15();
          }
        }

      });
    },

    onCategorySearch(searchTxt, loading) {
      loading(true);
      this.productCategoryFilter.search = searchTxt;
      this.searchMethodCategory(loading);
    },
    onCategoryFocus() {
      this.productCategoryFilter.search = '';
      this.searchMethodCategory();
    },
    searchMethodCategory(loading) {
      this.productCategories = [];
      this.productSubCategories = [];
      this.productCategoryFilter.objectId = this.fitment.parentId;
      this.$http.post('product-category-plus/search', this.productCategoryFilter).then(res => {
        if (loading)
          loading(false);
        this.productCategories = res.data.data;
      }, err => {
        console.log(err);
      });
    },


    onSubCategorySearch(searchTxt, loading) {
      if (!this.fitment.productCategoryPlusDto) {
        return;
      }
      loading(true);
      this.subCategoryFilter.search = searchTxt;
      this.subCategoryFilter.parentId = this.fitment.productCategoryPlusDto.id;
      this.searchMethodSubCategory(loading);
    },

    onSubCategoryFocus() {
      if (!this.fitment.productCategoryPlusDto) {
        return;
      }
      this.subCategoryFilter.search = '';
      this.subCategoryFilter.parentId = this.fitment.productCategoryPlusDto.id;
      this.searchMethodSubCategory();
    },

    searchMethodSubCategory(loading) {
      this.productSubCategories = [];
      this.$http.post('product-sub-category-plus/search', this.subCategoryFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.productSubCategories = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    onChangeMethodSub() {
      if (this.fitment.productCategoryPlusDto.fitmentType) {
        this.fitment.fitmentType = this.fitment.productCategoryPlusDto.fitmentType;
        this.fitment.customsDuty = this.fitment.productCategoryPlusDto.customsDuty;
      }
    },

    onProductManufactureSearch(searchTxt, loading) {
      loading(true);
      this.productManufactureFilter.search = searchTxt;
      this.productManufactureFilter.productCategoryId = this.fitment.productCategoryPlusDto.id;
      this.productManufactureFilter.productSubCategoryId = this.fitment.productSubCategoryPlusDto.id;
      this.searchProductManufacture(loading);
    },

    onProductManufactureFocus() {
      this.productManufactureFilter.search = '';
      this.productManufactureFilter.productCategoryId = this.fitment.productCategoryPlusDto.id;
      this.productManufactureFilter.productSubCategoryId = this.fitment.productSubCategoryPlusDto.id;
      this.searchProductManufacture();
    },

    searchProductManufacture(loading) {
      this.manufactures = [];
      this.$http.post('product-manufacture/search', this.productManufactureFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.manufactures = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    onProductModelSearch(searchTxt, loading) {
      loading(true);
      this.productModelFilter.search = searchTxt;

      this.productModelFilter.productCategoryId = this.fitment.productCategoryPlusDto.id;
      this.productModelFilter.productSubCategoryId = this.fitment.productSubCategoryPlusDto.id;
      this.productModelFilter.productManufactureId = this.fitment.productManufactureDto.id;

      this.searchProductModel(loading);
    },

    onProductModelFocus() {
      this.productModelFilter.search = '';
      this.productModelFilter.productCategoryId = this.fitment.productCategoryPlusDto.id;
      this.productModelFilter.productSubCategoryId = this.fitment.productSubCategoryPlusDto.id;
      this.productModelFilter.productManufactureId = this.fitment.productManufactureDto.id;
      this.searchProductModel();
    },

    searchProductModel(loading) {
      this.productModels = [];
      this.$http.post('product-model/search', this.productModelFilter)
          .then(res => {

            if (loading)
              loading(false);
            this.productModels = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    onCountrySearch(searchTxt) {
      this.countryList = [];
      this.filter.search = searchTxt;
      this.$http.post('country/search', this.filter)
          .then(res => {
            this.countryList = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onCountryFocus() {
      this.countryList = [];
      this.filter.search = '';
      this.$http.post('country/search', this.filter)
          .then(res => {
            this.countryList = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    changeDilapidationValue14() {
      if (!this.fitment.dilapidationValue) {
        return;
      }

      if (this.fitment.dilapidationValue <= 80) {
        if (this.fitment.dilapidationValue < 6) {
          this.fitment.technicalCondition = 'New';
          this.technicalConditionText = 'Янги';
        } else if (this.fitment.dilapidationValue < 20) {
          this.fitment.technicalCondition = 'VeryGood';
          this.technicalConditionText = 'Жуда яхши';
        } else if (this.fitment.dilapidationValue < 41) {
          this.fitment.technicalCondition = 'Good';
          this.technicalConditionText = 'Яхши';
        } else if (this.fitment.dilapidationValue < 61) {
          this.fitment.technicalCondition = 'Satisfactory';
          this.technicalConditionText = 'Қониқарли';
        } else if (this.fitment.dilapidationValue <= 80) {
          this.fitment.technicalCondition = 'Dissatisfied';
          this.technicalConditionText = 'Қониқарсиз';
        }
        this.calculated();
      } else {
        this.fitment.dilapidationValue = 80;
      }
    },

    changeDilapidationValue15() {
      if (!this.fitment.dilapidationValue) {
        return;
      }
      if (this.fitment.dilapidationValue === 0 || this.fitment.dilapidationValue === 5) {
        this.fitment.technicalCondition = 'New';
        this.technicalConditionText = 'Янги';
      } else if (this.fitment.dilapidationValue === 10 || this.fitment.dilapidationValue === 15) {
        this.fitment.technicalCondition = 'VeryGood';
        this.technicalConditionText = 'Жуда яхши';
      } else if (this.fitment.dilapidationValue === 20 || this.fitment.dilapidationValue === 25 ||
          this.fitment.dilapidationValue === 30 || this.fitment.dilapidationValue === 35) {
        this.fitment.technicalCondition = 'Good';
        this.technicalConditionText = 'Яхши';
      } else if (this.fitment.dilapidationValue === 40 || this.fitment.dilapidationValue === 45 ||
          this.fitment.dilapidationValue === 50 || this.fitment.dilapidationValue === 55 || this.fitment.dilapidationValue === 60) {
        this.fitment.technicalCondition = 'Satisfactory';
        this.technicalConditionText = 'Қониқарли';
      } else if (this.fitment.dilapidationValue === 65 || this.fitment.dilapidationValue === 70 ||
          this.fitment.dilapidationValue === 75 || this.fitment.dilapidationValue === 80) {
        this.fitment.technicalCondition = 'ConditionallyAvailable';
        this.technicalConditionText = 'Шартли равишда яроқли';
      } else if (this.fitment.dilapidationValue === 85 || this.fitment.dilapidationValue === 90) {
        this.fitment.technicalCondition = 'Dissatisfied';
        this.technicalConditionText = 'Қониқарсиз';
      } else if (this.fitment.dilapidationValue === 97.5 || this.fitment.dilapidationValue === 100) {
        this.fitment.technicalCondition = 'ToBad';
        this.technicalConditionText = 'Қўллашга яроқсиз';
      }
      this.calculated();
    },

    umchange(um) {
      this.fitment.unitMeasurementType = um.name
    },
    calculated() {
      const vm = this;
      if (vm.fitment.fitmentType !== 'JEWELRY') {

        let rate = 1;
        let usdPrice = vm.fitment.qty * vm.fitment.governmentPrice / vm.fitment.usdCurrencyRate;
        if (vm.fitment.currency === "USD") {
          rate = vm.fitment.usdCurrencyRate;
          usdPrice = vm.fitment.qty * vm.fitment.governmentPrice;
        } else if (vm.fitment.currency === "EUR") {
          rate = vm.fitment.eurCurrencyRate;
          usdPrice = vm.fitment.qty * vm.fitment.governmentPrice * rate / vm.fitment.usdCurrencyRate;
        } else if (vm.fitment.currency === "RUB") {
          rate = vm.fitment.rubCurrencyRate;
          usdPrice = vm.fitment.qty * vm.fitment.governmentPrice * rate / vm.fitment.usdCurrencyRate;
        }

        let netAmount = vm.fitment.qty * vm.fitment.governmentPrice * rate;
        if (vm.fitment.hasCustomsDuty) {
          if (vm.isNewStandard) {
            vm.getCoefficient(usdPrice);
            vm.fitment.customsClearance = vm.coefficient * vm.minSalary;
          }

          let vat = vm.fitment && vm.fitment.vat != null ? vm.fitment.vat : 0;
          let road = vm.fitment && vm.fitment.road != null ? vm.fitment.road : 0;
          let customsClearance = vm.fitment && vm.fitment.customsClearance != null ? vm.fitment.customsClearance : 0;
          let customsDuty = vm.fitment && vm.fitment.customsDuty != null ? vm.fitment.customsDuty : 0;

          if (!vm.isNewStandard) {

            netAmount =
                netAmount +
                (netAmount * vat / 100) +
                (netAmount * road / 100) +
                (netAmount * customsClearance / 100) +
                (netAmount * customsDuty / 100);

          } else {

            netAmount =
                netAmount +
                customsClearance +
                (netAmount * vat / 100) +
                (netAmount * road / 100) +
                (netAmount * customsDuty / 100);
          }
        }
        let dilapidationValue = vm.fitment.dilapidationValue ? vm.fitment.dilapidationValue : 0;
        vm.fitment.totalGovPrice = (netAmount - (netAmount * (dilapidationValue / 100)));

      } else if (vm.fitment.metalType && vm.metalTypes.length > 0) {

        for (let i = 0; i < vm.metalTypes.length; i++) {
          let field = vm.metalTypes[i];
          if (field.code === vm.fitment.metalType) {
            vm.fitment.metalRate = field.rate;
            vm.fitment.metalTypeName = field.displayName.toLowerCase();
            vm.fitment.gramPriceInSum = (vm.fitment.metalRate / 31.1034769 * vm.fitment.usdCurrencyRate);
            vm.fitment.governmentPrice = vm.fitment.gramPriceInSum * vm.fitment.hallmark * vm.fitment.weigh * vm.fitment.overlayCoefficient;
            vm.fitment.totalGovPrice = vm.fitment.governmentPrice + vm.fitment.stonePrice;
            vm.fitment.useWebSite = field.source;
            vm.fitment.metalType = field.code;
            vm.fitment.um = "GRAM"
          }
        }
      }
    },
    getCoefficient(usdPrice) {
      if (usdPrice < 10000) {
        this.coefficient = 1;
      } else if (usdPrice < 20000) {
        this.coefficient = 1.5;
      } else if (usdPrice < 40000) {
        this.coefficient = 2.5;
      } else if (usdPrice < 60000) {
        this.coefficient = 4;
      } else if (usdPrice < 100000) {
        this.coefficient = 8;
      } else if (usdPrice < 200000) {
        this.coefficient = 15;
      } else if (usdPrice < 500000) {
        this.coefficient = 30;
      } else if (usdPrice < 1000000) {
        this.coefficient = 58;
      } else {
        this.coefficient = 75;
      }
    }
  },
  created() {
    this.init();
  }
}
</script>

<style scoped>

</style>
